import {
  FETCH_PAGES,
  FETCH_PAGES_ERROR,
  FETCH_PAGES_SUCCESS,
} from "./../store/constants";

const doFetchPages = (payload) => ({
  type: FETCH_PAGES,
  payload,
});

const doFetchPagesSuccess = (payload) => ({
  type: FETCH_PAGES_SUCCESS,
  payload,
});

const doFetchPagesError = (payload) => ({
  type: FETCH_PAGES_ERROR,
  payload,
});

export { doFetchPages, doFetchPagesSuccess, doFetchPagesError };
